/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import AddReminder from '../addReminder/addReminder';
import _ from 'lodash';

export default function ReminderForm({ setStage, reminders, setReminders }) {
  const [fieldsFilled, setFieldsFilled] = useState(false);

  function updateValue(index, field, value) {
    setReminders(prev =>
      prev.map((item, i) =>
        i === index
          ? { ...item, [field]: value }
          : item
      )
    );

    validateReminders(index, field);
  }

  function addReminder() {
    if (reminders.length >= 5) { return; }
    setReminders(prev => [
      ...prev,
      {
        insuranceType: null,
        insurer: null,
        renewalMonth: null,
        annualPayment: null,
        errors: {}
      }
    ]);
  }
  
  function removeReminder(index) {
    setReminders(prev => _.filter(prev, (reminder, i) => i !== index));
  }

  // This could be better but, works
  // If reminderInxed and reminderField are present, only that field of that reminder will be validated
  function validateReminders(reminderIndex, reminderField) {
    let hasError = false;

    setReminders(prev =>
      _.map(prev, (reminder, index) => {
        // Skip other reminders if index provided
        if (!_.isNil(reminderIndex) && index !== reminderIndex) {
          return reminder;
        }

        const validators = {
          insuranceType: !reminder.insuranceType ? 'Este campo é obrigatório' : null,
          insurer: !reminder.insurer ? 'Este campo é obrigatório' : null,
          renewalMonth: !reminder.renewalMonth ? 'Este campo é obrigatório' : null,
          annualPayment: reminder.annualPayment === '.' ? 'Insira um valor válido' : null
        };

        hasError = _.some(validators, field => field !== null);

        // If specific field is provided update only that field
        if (reminderField) {
          return {
            ...reminder,
            errors: {
              ...reminder.errors,
              [reminderField]: validators[reminderField]
            }
          };
        }

        // Otherwise update all fields of this reminder
        return {
          ...reminder,
          errors: {
            ...reminder.errors,
            ...validators
          }
        };
      })
    );

    return !hasError;
  }

  function submit() {
    const success = validateReminders();

    if (!success || !fieldsFilled) { return; }

    setStage('REVIEW');
  }

  // Update the status of all the fields, if they are filled 
  useEffect(() => {
    const fieldsFilled = _.every(reminders, reminder =>
      _.every(reminder, (value, field) => _.includes(['errors', 'annualPayment'], field) || value !== null)
    );

    setFieldsFilled(fieldsFilled);
  }, [reminders])

  return(
    <>
      <span>Regista um seguro para te avisarmos antes da renovação</span>
      <p>Recebe um aviso 30 dias antes da renovação e evita decisões à última hora.</p>
      <div className="reminder-scroll">
        {reminders?.map((reminder, index) => (
          <AddReminder key={index} values={reminder} updateValue={(field, value) => updateValue(index, field, value)} closeReminder={removeReminder} index={index} remindersCount={reminders.length} />
        ))}
      </div>
      <span onClick={addReminder} style={reminders.length >= 5 ? { opacity: .4, cursor: 'not-allowed' } : {}} className="add-more-reminders">+ Tenho mais um seguro para registar</span>
      <button onClick={submit} style={!fieldsFilled ? { opacity: .4, cursor: 'not-allowed' } : {}} className="reminder-button-active">Guardar e activar aviso</button>
      <p style={{ width: '100%', marginTop: '5px', textAlign: 'center' }}>Nada muda no teu seguro. Só ganhas tempo.</p>
    </>
  );
}